import React from "react";
import { Paper, Stack, Typography, Box } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

import CMKpiCard from "./CMKpiCard";
import InfoButton from "../Clinical/InfoButton";

/**
 * Panel 1: Care Management Overview — 4 KPI cards.
 * KPIs: In Active CM, Unmanaged High Risk, Post-Discharge Pending, ER Frequent Flyers
 */
export default function PanelCMOverview({ kpis, loading, onScrollToPanel, helpContent }) {
  const cards = [
    {
      label: "In Active CM",
      value: kpis?.inActiveCM,
      icon: <PeopleIcon sx={{ fontSize: 18 }} />,
      color: "#2563EB",
      bgColor: "#EFF6FF",
    },
    {
      label: "Unmanaged High Risk",
      value: kpis?.unmanagedHighRisk,
      icon: <ReportProblemIcon sx={{ fontSize: 18 }} />,
      color: kpis?.unmanagedHighRisk > 0 ? "#DC2626" : "#16A34A",
      bgColor: kpis?.unmanagedHighRisk > 0 ? "#FEE2E2" : "#DCFCE7",
      onClick: () => onScrollToPanel?.("unmanagedRisk"),
    },
    {
      label: "Post-Discharge Pending",
      value: kpis?.postDischargePending,
      icon: <TransferWithinAStationIcon sx={{ fontSize: 18 }} />,
      color: kpis?.postDischargePending > 0 ? "#D97706" : "#16A34A",
      bgColor: kpis?.postDischargePending > 0 ? "#FEF3C7" : "#DCFCE7",
      onClick: () => onScrollToPanel?.("transitions"),
    },
    {
      label: "ER Frequent Flyers",
      value: kpis?.erFrequentFlyers,
      icon: <LocalHospitalIcon sx={{ fontSize: 18 }} />,
      color: kpis?.erFrequentFlyers > 0 ? "#DC2626" : "#16A34A",
      bgColor: kpis?.erFrequentFlyers > 0 ? "#FEE2E2" : "#DCFCE7",
      onClick: () => onScrollToPanel?.("erUtilization"),
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: 1.5,
              bgcolor: "#EFF6FF",
              color: "#2563EB",
            }}
          >
            <PeopleIcon sx={{ fontSize: 16 }} />
          </Box>
          <Typography variant="subtitle2" fontWeight={700}>
            Care Management Overview
          </Typography>
          <InfoButton helpContent={helpContent} />
        </Stack>

        {/* KPI Grid */}
        <Box
          sx={{
            display: "grid",
            gap: 2,
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            },
          }}
        >
          {cards.map((card) => (
            <CMKpiCard key={card.label} {...card} loading={loading} />
          ))}
        </Box>
      </Stack>
    </Paper>
  );
}
